import '.g4{border:var(--gray-border);}.ssr-plugin'
import '.co{background:var(--shades-white);}.ssr-plugin'
import '.ad{border-radius:1.25rem;}.ssr-plugin'
import { Property } from 'csstype'
import { styled, Style } from 'inlines'
import { ReactNode } from 'react'

export type CardWrapperProps = {
  children: ReactNode
  padding?: Property.Padding
  style?: Style
  onClick?: VoidFunction
}

export const CardWrapper = ({
  children,
  padding = '1rem',
  style,
  onClick,
}: CardWrapperProps) => {
  return (
    <styled.div className="g4 co ad"
      onClick={onClick}
      style={{
        padding: padding,
        cursor: onClick ? 'pointer' : 'auto',
        ...style,
      }}
    >
      {children}
    </styled.div>
  )
}
